import { TriangleAlert, XCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../hooks";
import type { UsageStatistic } from "../../types/subscription";
import { subscriptionGuardModalMessage } from "../../assets/subscriptionGuardModalMessages";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    type: UsageStatistic;
    message?: string;
    title?: string;
}

const SubscriptionGuardModal : React.FC<Props> = ({ 
    type,
    message = subscriptionGuardModalMessage[type].message,
    title = subscriptionGuardModalMessage[type].title,
    isOpen,
    onClose
}) => {

    const navigate = useNavigate();
    // const userDetails = useAppSelector((state) => state.auth.user);
    // const userRole = userDetails?.main_role;
    const activeRole = useAppSelector((state) => state.auth).activeRole;

    if(!isOpen) return null;

    return ( 
        <div className="modal">
            <div className="modal-body p-4 flex flex-col gap-4">

                {/* MODAL HEADER */}
                <div className="flex justify-between">
                    <div>
                        <h2 className="text-xl font-semibold text-primary mb-4">Limit Reached</h2>
                    </div>
                    <div>
                        <XCircle 
                            color="red" 
                            className="cursor-pointer" 
                            onClick={onClose}  
                        />
                    </div>
                </div>


                {/* BODY */}
                <div className="flex items-center text-center flex-col gap-3">
                    {/* TITLE */}
                    <TriangleAlert size={64} color="red"/>
                    <h1 className="sm:text-md text-2xl font-semibold text-primary">
                        {title}
                    </h1>

                    {/* MESSAGE */}
                    <p className="sm:text-sm text-xl text-gray-800">
                        {message}
                    </p>

                    {/* ADMIN HAS THE OPTION TO RENEW PLAN */}
                    {activeRole == "Admin" ? (
                        <button 
                            className="form-btn mt-4"
                            onClick={() => navigate("/plans")}
                        >
                            Go to Plans
                        </button>
                    ) : (
                        <p className="text-lg mt-4 font-bold">
                            Contact your Business Admin to purchase a new subscription
                        </p>
                    )}
                </div>
            </div>
        </div>
     );
}
 
export default SubscriptionGuardModal;